import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Container } from './AuthLayout.styles';
import { useSelector } from 'react-redux';
import { selectIsLoggedIn } from '../../store/slices/auth/slice';
import { HOME } from '../../components/App/routes';

const AuthLayout = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (isLoggedIn) {
    return <Navigate to={HOME} />;
  }

  return (
    <Container>
      <Outlet />
    </Container>
  );
};

export default AuthLayout;
